export default __webpack_public_path__ + "static/media/8.d5ab4200.png";